<section class="mat-typography app-container">
  <app-header></app-header>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</section>
